// ec-cart-coupon.js
(function () {
  let initialized = false;

  function initCouponScript() {
    if (initialized) return;
    const input = document.getElementById('ec-cupom-input');
    if (!input) return;
    initialized = true;

    const button = document.getElementById('ec-apply-coupon-button');
    const badges = document.getElementById('ec-coupon-badges');
    const message = document.getElementById('ec-coupon-message');
    if (!input || !button || !badges) return;

    function getAppliedCouponsFromCart(cart) {
      if (!cart) return [];
      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
        return cart.cart_level_discount_applications.map(d => (d.title || d.code || '').toString().trim()).filter(Boolean);
      }
      if (cart.discount_codes && cart.discount_codes.length > 0) {
        return cart.discount_codes
          .filter(d => d.applicable === true)
          .map(d => (d.code || '').toString().trim())
          .filter(Boolean);
      }
      return [];
    }

    function isCouponApplicable(cart, code) {
      if (!cart || !code) return false;
      const codeNorm = code.toLowerCase().trim();
      if (cart.discount_codes && cart.discount_codes.length > 0) {
        return cart.discount_codes.some(d => (d.code || '').toLowerCase().trim() === codeNorm && d.applicable === true);
      }
      return false;
    }

    function getCurrentCouponsFromCart() {
      return fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => res.json())
        .then(cart => getAppliedCouponsFromCart(cart))
        .catch(() => {
          const couponBadges = badges.querySelectorAll('[data-coupon-code]');
          return Array.from(couponBadges).map(badge => badge.getAttribute('data-coupon-code')).filter(Boolean);
        });
    }

    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    function renderBadges(coupons) {
      if (!coupons || coupons.length === 0) {
        badges.innerHTML = '';
        return;
      }
      const checkUrl = badges.getAttribute('data-check-icon-url') || '';
      badges.innerHTML = `
        <ul class="ec-discounts-list" role="list">
          ${coupons.map(coupon => `
            <li class="ec-coupon-badge" data-coupon-code="${escapeHtml(coupon)}" data-remove-discount>
              <span class="ec-coupon-badge__icon" aria-hidden="true">
                ${checkUrl ? '<img src="' + checkUrl.replace(/"/g, '&quot;') + '" alt="" width="20" height="20">' : ''}
              </span>
              <span class="ec-coupon-badge__text">O cupom (${escapeHtml(coupon)}) foi aplicado com sucesso.</span>
              <button
                type="button"
                class="ec-coupon-badge__remove"
                aria-label="Remover cupom"
              >Remover</button>
            </li>
          `).join('')}
        </ul>
      `;
      badges.querySelectorAll('.ec-coupon-badge__remove').forEach(btn => {
        btn.addEventListener('click', function() {
          const badge = btn.closest('[data-coupon-code]');
          const codeToRemove = badge.getAttribute('data-coupon-code');
          removeCoupon(codeToRemove);
        });
      });
    }

    function formatMoney(cents) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function updateCartSummary(cart) {
      const subtotalEl = document.getElementById('ec-cart-subtotal');
      const totalEl = document.getElementById('ec-cart-total-value');
      const couponLineEl = document.getElementById('ec-cart-footer-coupon-line');
      const couponValueEl = document.getElementById('ec-cart-coupon-value');
      if (subtotalEl && cart && cart.total_price != null) {
        const subtotal = (cart.total_price || 0) + (cart.total_discount || 0);
        subtotalEl.textContent = formatMoney(subtotal);
      }
      if (totalEl && cart && cart.total_price != null) {
        totalEl.textContent = formatMoney(cart.total_price);
      }
      if (couponLineEl && couponValueEl && cart) {
        if (cart.total_discount && cart.total_discount > 0) {
          couponLineEl.style.display = 'flex';
          couponValueEl.textContent = '- ' + formatMoney(cart.total_discount);
          couponValueEl.style.color = '#1a7f37';
        } else {
          couponLineEl.style.display = 'none';
        }
      }
    }

    function applyMultipleDiscountCodes(codes) {
      if (!codes || codes.length === 0) {
        return fetch(window.Shopify.routes.root + 'cart.js').then(res => res.json());
      }
      return codes.reduce((promiseChain, code) => {
        return promiseChain.then(() => 
          fetch(window.Shopify.routes.root + 'discount/' + encodeURIComponent(code), {
            method: 'GET',
            credentials: 'same-origin'
          })
        );
      }, Promise.resolve())
      .then(() => fetch(window.Shopify.routes.root + 'cart.js'))
      .then(res => res.json());
    }

    function applyDiscountCode(code) {
      return fetch(window.Shopify.routes.root + 'discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin'
      })
      .then(() => fetch(window.Shopify.routes.root + 'cart.js'))
      .then(res => res.json());
    }

    function clearDiscountCodes() {
      return fetch(window.Shopify.routes.root + 'checkout?discount=', {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'manual'
      })
      .catch(() => {})
      .then(() => fetch(window.Shopify.routes.root + 'cart.js'))
      .then(res => res.json());
    }

    button.addEventListener('click', applyCoupon);

    function applyCoupon() {
      const code = input.value.trim();
      if (!code) {
        showMessage('Digite um código de cupom.', 'error');
        return;
      }

      button.disabled = true;
      button.innerHTML = '<span class="ec-spinner"></span>';
      showMessage('Aplicando cupom...', 'loading');

      const codeNorm = code.toLowerCase().trim();
      
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => res.json())
        .then(cartBefore => {
          const currentCoupons = getAppliedCouponsFromCart(cartBefore);
          if (currentCoupons.some(c => (c || '').toLowerCase().trim() === codeNorm)) {
            showMessage('Este cupom já foi aplicado.', 'error');
            button.disabled = false;
            button.innerHTML = 'Usar cupom';
            return;
          }

          const allCoupons = [...currentCoupons, code];
          return clearDiscountCodes()
            .then(() => applyMultipleDiscountCodes(allCoupons))
            .then(cartAfter => {
              const appliedCoupons = getAppliedCouponsFromCart(cartAfter);
              const isApplicable = isCouponApplicable(cartAfter, code);
              if (isApplicable) {
                renderBadges(appliedCoupons);
                updateCartSummary(cartAfter);
                input.value = '';
                if (message) {
                  message.style.display = 'none';
                  message.innerHTML = '';
                }
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartAfter }));
              } else {
                clearDiscountCodes()
                  .then(() => applyMultipleDiscountCodes(currentCoupons))
                  .then(cartRestored => {
                    const restoredCoupons = getAppliedCouponsFromCart(cartRestored);
                    renderBadges(restoredCoupons);
                    updateCartSummary(cartRestored);
                    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartRestored }));
                  });
                showMessage('Cupom inválido ou não aplicável.', 'error');
              }
            });
        })
        .catch((err) => {
          showMessage('Erro ao aplicar o cupom.', 'error');
        })
        .finally(() => {
          button.disabled = false;
          button.innerHTML = 'Usar cupom';
        });
    }

    function removeCoupon(codeToRemove) {
      if (message) {
        message.style.display = 'block';
        message.textContent = 'Removendo cupom...';
        message.className = 'ec-coupon-message ec-coupon-message--loading';
      }
      if (button) {
        button.disabled = true;
        button.innerHTML = '<span class="ec-spinner"></span>';
      }

      getCurrentCouponsFromCart()
        .then(currentCoupons => {
          const couponsToReapply = currentCoupons.filter(c => 
            (c || '').trim().toLowerCase() !== (codeToRemove || '').trim().toLowerCase()
          );
          return clearDiscountCodes()
            .then(() => {
              if (couponsToReapply.length === 0) {
                return fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());
              }
              return couponsToReapply.reduce((promiseChain, coupon) => {
                return promiseChain.then(() => applyDiscountCode(coupon));
              }, Promise.resolve())
              .then(() => fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json()));
            })
            .then(cart => {
              const appliedCoupons = getAppliedCouponsFromCart(cart);
              renderBadges(appliedCoupons);
              updateCartSummary(cart);
              if (message) {
                message.style.display = 'none';
                message.innerHTML = '';
              }
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            });
        })
        .catch(() => {
          if (message) {
            message.textContent = 'Erro ao remover o cupom.';
            message.className = 'ec-coupon-message ec-coupon-message--error';
          }
        })
        .finally(() => {
          if (button) {
            button.disabled = false;
            button.innerHTML = 'Usar cupom';
          }
        });
    }

    let messageTimeout = null;
    function showMessage(text, type) {
      if (messageTimeout) {
        clearTimeout(messageTimeout);
        messageTimeout = null;
      }
      if (!message) return;
      message.style.display = 'block';
      message.textContent = text;
      message.className = 'ec-coupon-message ec-coupon-message--' + type;
      if (type !== 'loading') {
        messageTimeout = setTimeout(() => {
          message.style.display = 'none';
          message.innerHTML = '';
          messageTimeout = null;
        }, 4000);
      }
    }

    function initBadges() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => res.json())
        .then(cart => {
          const appliedCoupons = getAppliedCouponsFromCart(cart);
          if (appliedCoupons.length > 0) {
            renderBadges(appliedCoupons);
          }
          updateCartSummary(cart);
        })
        .catch(() => {});
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBadges);
    } else {
      initBadges();
    }

    document.addEventListener('click', function (event) {
      const removeButton = event.target.closest('[data-remove-discount] button');
      if (!removeButton) return;
      event.preventDefault();
      const badge = removeButton.closest('[data-coupon-code]');
      if (!badge) return;
      const codeToRemove = badge.getAttribute('data-coupon-code');
      if (codeToRemove) {
        removeCoupon(codeToRemove);
      }
    });

    document.addEventListener('cart:updated', function(event) {
      if (event.detail) {
        updateCartSummary(event.detail);
      }
    });
  }

  if (!window.__EC_CART_COUPON_OBSERVED) {
    window.__EC_CART_COUPON_OBSERVED = true;
    const observer = new MutationObserver(() => {
      initCouponScript();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  initCouponScript();
})();
